<div [ngClass]="{'app-light-theme': !themeService.isDark, 'app-dark-theme': themeService.isDark}">
	<h2 mat-dialog-title>{{'Session.Warning.Title' | translate}}</h2>
	<div mat-dialog-content>
		<p [id]="messageId">{{'Session.Warning.Message' | translate}}</p>
		<p class="countdown" aria-hidden="true">{{'Session.Warning.Countdown' | translate:{ time: countdown } }}</p>
		<p class="visually-hidden" aria-live="polite">{{announcement}}</p>
	</div>
	<div mat-dialog-actions class="button">
		<button mat-button cdkFocusInitial (click)="onExtend()">{{'Session.Warning.Extend' | translate}}</button>
		<button mat-button class="secondary" (click)="onSignOut()">{{'Session.Warning.SignOut' | translate}}</button>
	</div>
</div>
